type TParams = {
  idAnuncio?: number;
  cliente: {
    email: string;
    foneCelular?: string;
    numeroCep?: string;
    nome: string;
    sobrenome?: string;
    cpf?: string;
  };
  items: Array<{ id: number; titulo: string }>;
  formasPagamento: Array<{
    precoPor: number;
    key: string;
  }>;
  pedido?: { id: number };
  formaPagamento: string;
  value?: number;
};

export default function getTrackDataPayload({
  idAnuncio,
  cliente,
  items,
  formasPagamento,
  formaPagamento,
  pedido,
  value,
}: TParams) {
  const contents = items.reduce<{ name: string[]; id: number[] }>(
    (acc, actual) => ({
      name: [...acc.name, actual.titulo],
      id: [...acc.id, actual.id],
    }),
    { name: [], id: [] },
  );

  const finalValue =
    value || getValueFromPaymentMethods({ formasPagamento, formaPagamento });

  return {
    'e-mail': cliente.email,
    telefone: cliente.foneCelular,
    cep: cliente.numeroCep,
    nome: cliente.nome,
    cpf: cliente.cpf,
    sobrenome: cliente.sobrenome?.trim(),
    content_ids: contents.id.join(', '),
    content_name: contents.name.join(', '),
    num_items: items.length,
    value: finalValue,
    order_id: pedido?.id,
    idAnuncio,
  };
}

function getValueFromPaymentMethods(params: {
  formasPagamento: Array<{
    precoPor: number;
    key: string;
  }>;
  formaPagamento: string;
}) {
  const chosenMethod = params.formasPagamento.find(
    method => method.key === params.formaPagamento,
  );

  return chosenMethod?.precoPor || 0;
}
